import * as React from "react";
const SvgNews20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M6 6h8v7H6V6Zm2 5h4V8H8v3Z",
      clipRule: "evenodd"
    }),
    React.createElement("path", { fill: "current", d: "M6 16h8v-2H6v2Z" }),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M15 3h2v16H3V3l12-2v2Zm0 2H5v12h10V5Z",
      clipRule: "evenodd"
    })
  );
export default SvgNews20Px;
